/* L'Paige homepage Halloween banner (sections/lp-halloween-banner): follows the event dates — countdown
   to the start (teaser) or the end, and hides itself once the event is over. */
(function () {
  if (window.__lpHalloweenBanner) return;
  window.__lpHalloweenBanner = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (root.__lpHb) return;
    root.__lpHb = true;
    var start = Date.parse(root.dataset.start || '');
    var end = Date.parse(root.dataset.end || '');
    var showBefore = root.dataset.showBefore !== 'false';
    var editor = root.hasAttribute('data-editor');
    var count = root.querySelector('[data-hb-count]');
    var units = root.querySelectorAll('[data-hb-unit]');
    var whens = root.querySelectorAll('[data-hb-when]');
    var section = root.closest('.shopify-section') || root;
    var timer;

    function tick() {
      var now = Date.now();
      var state = !isNaN(start) && now < start ? 'pre' : !isNaN(end) && now >= end ? 'ended' : 'live';
      if (editor && root.dataset.state) state = root.dataset.state === 'ended' ? state : root.dataset.state;
      if (!editor && (state === 'ended' || (state === 'pre' && !showBefore))) {
        section.hidden = true;
        clearInterval(timer);
        return;
      }
      whens.forEach(function (el) { el.hidden = el.dataset.hbWhen.split(' ').indexOf(state) === -1; });
      var target = state === 'pre' ? start : end;
      var left = isNaN(target) ? 0 : Math.floor((target - now) / 1000);
      if (count) count.hidden = left <= 0;
      if (left <= 0) return;
      var parts = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      units.forEach(function (el) { el.textContent = pad(parts[el.dataset.hbUnit]); });
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function boot() { document.querySelectorAll('[data-lp-hb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-hb]');
    if (root) init(root);
  });
})();
